const BaseTbody = ({ children }) => {
  return <tbody>{children}</tbody>;
};

export default BaseTbody;
